import { Route } from '@angular/router';

export const structureRoutes: Route[] = [
  // ── Grupos ────────────────────────────────────────────────────────────────
  {
    path: 'groups',
    loadComponent: () =>
      import('./groups/groups.component').then((m) => m.GroupsComponent),
  },
  {
    path: 'groups/new',
    loadComponent: () =>
      import('./groups/groups.component').then((m) => m.GroupsComponent),
  },
  {
    path: 'groups/nuevo',
    loadComponent: () =>
      import('./groups/groups.component').then((m) => m.GroupsComponent),
  },
  {
    path: 'groups/:id/edit',
    loadComponent: () =>
      import('./groups/groups.component').then((m) => m.GroupsComponent),
  },
  {
    path: 'groups/:id/editar',
    loadComponent: () =>
      import('./groups/groups.component').then((m) => m.GroupsComponent),
  },
  {
    path: 'groups/:id/view',
    loadComponent: () =>
      import('./groups/groups.component').then((m) => m.GroupsComponent),
  },
  {
    path: 'groups/:id/ver',
    loadComponent: () =>
      import('./groups/groups.component').then((m) => m.GroupsComponent),
  },

  // ── Empresas ──────────────────────────────────────────────────────────────
  {
    path: 'companies',
    loadComponent: () =>
      import('./companies/companies.component').then(
        (m) => m.CompaniesComponent,
      ),
  },
  {
    path: 'companies/new',
    loadComponent: () =>
      import('./companies/companies.component').then(
        (m) => m.CompaniesComponent,
      ),
  },
  {
    path: 'companies/nuevo',
    loadComponent: () =>
      import('./companies/companies.component').then(
        (m) => m.CompaniesComponent,
      ),
  },
  {
    path: 'companies/:id/edit',
    loadComponent: () =>
      import('./companies/companies.component').then(
        (m) => m.CompaniesComponent,
      ),
  },
  {
    path: 'companies/:id/editar',
    loadComponent: () =>
      import('./companies/companies.component').then(
        (m) => m.CompaniesComponent,
      ),
  },
  {
    path: 'companies/:id/view',
    loadComponent: () =>
      import('./companies/companies.component').then(
        (m) => m.CompaniesComponent,
      ),
  },
  {
    path: 'companies/:id/ver',
    loadComponent: () =>
      import('./companies/companies.component').then(
        (m) => m.CompaniesComponent,
      ),
  },

  // ── Sucursales ────────────────────────────────────────────────────────────
  {
    path: 'branches',
    loadComponent: () =>
      import('./branches/branches.component').then((m) => m.BranchesComponent),
  },
  {
    path: 'branches/new',
    loadComponent: () =>
      import('./branches/branches.component').then((m) => m.BranchesComponent),
  },
  {
    path: 'branches/nuevo',
    loadComponent: () =>
      import('./branches/branches.component').then((m) => m.BranchesComponent),
  },
  {
    path: 'branches/:id/edit',
    loadComponent: () =>
      import('./branches/branches.component').then((m) => m.BranchesComponent),
  },
  {
    path: 'branches/:id/editar',
    loadComponent: () =>
      import('./branches/branches.component').then((m) => m.BranchesComponent),
  },
  {
    path: 'branches/:id/view',
    loadComponent: () =>
      import('./branches/branches.component').then((m) => m.BranchesComponent),
  },
  {
    path: 'branches/:id/ver',
    loadComponent: () =>
      import('./branches/branches.component').then((m) => m.BranchesComponent),
  },

  // ── Corresponsales ────────────────────────────────────────────────────────
  {
    path: 'correspondents',
    loadComponent: () =>
      import('./correspondents/correspondents.component').then(
        (m) => m.CorrespondentsComponent,
      ),
  },

  // ── Precios y Tarifas ─────────────────────────────────────────────────────
  {
    path: 'pricing/new',
    loadComponent: () =>
      import('./pricing/pricing.component').then((m) => m.PricingComponent),
  },
  {
    path: 'pricing/nuevo',
    loadComponent: () =>
      import('./pricing/pricing.component').then((m) => m.PricingComponent),
  },
  {
    path: 'pricing/:id/edit',
    loadComponent: () =>
      import('./pricing/pricing.component').then((m) => m.PricingComponent),
  },
  {
    path: 'pricing/:id/editar',
    loadComponent: () =>
      import('./pricing/pricing.component').then((m) => m.PricingComponent),
  },
  {
    path: 'pricing/:id/view',
    loadComponent: () =>
      import('./pricing/pricing.component').then((m) => m.PricingComponent),
  },
  {
    path: 'pricing/:id/ver',
    loadComponent: () =>
      import('./pricing/pricing.component').then((m) => m.PricingComponent),
  },
  {
    path: 'pricing',
    loadComponent: () =>
      import('./pricing/pricing.component').then((m) => m.PricingComponent),
  },
];

/** Alias en español para compatibilidad con links existentes */
export const estructuraRoutes: Route[] = [
  {
    path: 'grupos',
    loadComponent: () =>
      import('./groups/groups.component').then((m) => m.GroupsComponent),
  },
  {
    path: 'grupos/nuevo',
    loadComponent: () =>
      import('./groups/groups.component').then((m) => m.GroupsComponent),
  },
  {
    path: 'grupos/:id/editar',
    loadComponent: () =>
      import('./groups/groups.component').then((m) => m.GroupsComponent),
  },
  {
    path: 'grupos/:id/ver',
    loadComponent: () =>
      import('./groups/groups.component').then((m) => m.GroupsComponent),
  },

  {
    path: 'empresas',
    loadComponent: () =>
      import('./companies/companies.component').then(
        (m) => m.CompaniesComponent,
      ),
  },
  {
    path: 'empresas/nuevo',
    loadComponent: () =>
      import('./companies/companies.component').then(
        (m) => m.CompaniesComponent,
      ),
  },
  {
    path: 'empresas/:id/editar',
    loadComponent: () =>
      import('./companies/companies.component').then(
        (m) => m.CompaniesComponent,
      ),
  },
  {
    path: 'empresas/:id/ver',
    loadComponent: () =>
      import('./companies/companies.component').then(
        (m) => m.CompaniesComponent,
      ),
  },

  {
    path: 'sucursales',
    loadComponent: () =>
      import('./branches/branches.component').then((m) => m.BranchesComponent),
  },
  {
    path: 'sucursales/nuevo',
    loadComponent: () =>
      import('./branches/branches.component').then((m) => m.BranchesComponent),
  },
  {
    path: 'sucursales/:id/editar',
    loadComponent: () =>
      import('./branches/branches.component').then((m) => m.BranchesComponent),
  },
  {
    path: 'sucursales/:id/ver',
    loadComponent: () =>
      import('./branches/branches.component').then((m) => m.BranchesComponent),
  },

  {
    path: 'precios-y-tarifas/nuevo',
    loadComponent: () =>
      import('./pricing/pricing.component').then((m) => m.PricingComponent),
  },
  {
    path: 'precios-y-tarifas/:id/editar',
    loadComponent: () =>
      import('./pricing/pricing.component').then((m) => m.PricingComponent),
  },
  {
    path: 'precios-y-tarifas/:id/ver',
    loadComponent: () =>
      import('./pricing/pricing.component').then((m) => m.PricingComponent),
  },
  {
    path: 'precios-y-tarifas',
    loadComponent: () =>
      import('./pricing/pricing.component').then((m) => m.PricingComponent),
  },
];
